import { types, actions } from './requests'
export const GETDOCUMENT_TYPES = {
    ...types('GETDOCUMENT'),
}
export const GETDOCUMENT_ACTIONS = {
    ...actions('GETDOCUMENT'),
}
